import { sum } from "lodash";
import { ReportDataModel } from "../models/report.model";
import { titleStr } from "../lib/helper";

export function getCustomerTrafficKey(data?: ReportDataModel) {
  const total = sum([
    data?.main.veryhigh_key_1,
    data?.main.high_key_2,
    data?.main.moderate_key_3,
    data?.main.low_key_4,
    data?.main.verylow_key_5,
  ]);
  return {
    veryHigh: {
      label: "Very High",
      value: (data?.main.veryhigh_key_1 || 0) / total,
    },
    high: { label: "High", value: (data?.main.high_key_2 || 0) / total },
    moderate: {
      label: "Moderate",
      value: (data?.main.moderate_key_3 || 0) / total,
    },
    low: { label: "Low", value: (data?.main.low_key_4 || 0) / total },
    veryLow: {
      label: "Very Low",
      value: (data?.main.verylow_key_5 || 0) / total,
    },
  };
}

export function getCustomerTrafficTimePeriod(
  data?: ReportDataModel,
): { label: string; value: number }[] {
  const total = sum([
    data?.main["9am_key_1"],
    data?.main["11am_key_2"],
    data?.main["1pm_key_3"],
    data?.main["4pm_key_4"],
    data?.main["7pm_key_5"],
    data?.main.other_key_6,
  ]);
  return [
    { label: "9:00 AM", value: (data?.main["9am_key_1"] || 0) / total },
    { label: "11:00 AM", value: (data?.main["11am_key_2"] || 0) / total },
    { label: "1:00 PM", value: (data?.main["1pm_key_3"] || 0) / total },
    { label: "4:00 PM", value: (data?.main["4pm_key_4"] || 0) / total },
    { label: "7:00 PM", value: (data?.main["7pm_key_5"] || 0) / total },
    { label: "Other", value: (data?.main["other_key_6"] || 0) / total },
  ];
}

export function getProductPromotionalPresence(
  data?: ReportDataModel,
): { label: string; value: number }[] {
  const total = sum([
    data?.main["desktopdisplay_key_1"],
    data?.main["shelfdisplay_key_1"],
    data?.main["poster_key_1"],
    data?.main["sticker_key_1"],
    data?.main["none_key_1"],
    data?.main.other_key_1,
  ]);
  return [
    {
      label: "Desktop",
      value: (data?.main["desktopdisplay_key_1"] || 0) / total,
    },
    { label: "Shelf", value: (data?.main["shelfdisplay_key_1"] || 0) / total },
    { label: "Poster", value: (data?.main["poster_key_1"] || 0) / total },
    { label: "Sticker", value: (data?.main["sticker_key_1"] || 0) / total },
    { label: "None", value: (data?.main["none_key_1"] || 0) / total },
    { label: "Other", value: (data?.main["other_key_1"] || 0) / total },
  ];
}

export function getTopSellers(
  data?: ReportDataModel,
): { label: string; value: number }[] {
  const keys = [
    "eb600",
    "eb600v2",
    "eb1200",
    "elfa_pro5",
    "bm600",
    "bm6000",
    "tappo",
    "liquids",
    "none",
    "other",
  ];
  const total = sum(keys.map((k) => data?.main[`${k}_key_1`]));
  return keys.map((k) => ({
    label: titleStr(k),
    value: (data?.main[`${k}_key_1`] || 0) / total,
  }));
}

export const productLabelKey: any = {
  elfbar: "Elfbar",
  lostmary: "LostMary",
  ske: "SKE",
  ivg: "IVG",
  instaflow: "Instaflow",
  hayati: "Hayati",
  other: "Other",
  none: "None",
};
export const productKeys = [
  "elfbar",
  "lostmary",
  "ske",
  "ivg",
  "instaflow",
  "hayati",
  "other",
];

export function getUnitSalesPerformers(data?: ReportDataModel) {
  const totalSum = sum(productKeys.map((k) => data?.main[`top_${k}_key_1`]));
  const secondlSum = sum(
    productKeys.map((k) => data?.main[`second_${k}_key_1`]),
  );
  const thirdSum = sum(productKeys.map((k) => data?.main[`third_${k}_key_1`]));
  return {
    labels: ["Top", "Second", "Third"],
    products: productKeys.map((k) => ({
      label: productLabelKey[k] || titleStr(k),
      value: [
        (data?.main[`top_${k}_key_1`] || 0) / totalSum,
        (data?.main[`second_${k}_key_1`] || 0) / secondlSum,
        (data?.main[`third_${k}_key_1`] || 0) / thirdSum,
      ],
    })),
  };
}

export function getDemonstratedSoldGave(
  type: "demonstrated" | "sold" | "gave",
  data?: ReportDataModel,
): { label: string; value: number }[] {
  const keys = ["berry", "fruits", "pineapple", "purple", "special"];
  const arrs = Array(100).fill("");
  return keys.map((k) => ({
    label: titleStr(k),
    value: sum(
      arrs.map((_, i) => {
        return i * (data?.main[`${k}_${type}_key_${i}_1`] || 0);
      }),
    ),
  }));
}

export function getPromoOffer(
  data?: ReportDataModel,
): { label: string; value: number }[] {
  const keys = [...productKeys, "none"];
  const total = sum(keys.map((k) => data?.main[`promooffer_${k}_key_1`]));
  return keys.map((k) => ({
    label: productLabelKey[k],
    value: (data?.main[`promooffer_${k}_key_1`] || 0) / total,
  }));
}

export function getCustomersEBTotal(data?: ReportDataModel) {
  const arrs = Array(26).fill("");
  return sum(
    arrs.map((_, i) => i * (data?.main[`customers_eb_key_${i}_1`] || 0)),
  );
}

export const vapeTypes = [
  "ease",
  "stock",
  "knowledge",
  "visible",
  "condition",
  "organised",
];

export function getVapeTakenUp(data?: ReportDataModel) {
  const arrs = Array(101).fill("");
  let total = 0;
  const val =
    sum(
      arrs.map((_, i) => {
        const v = data?.main[`vapeproportion_percent_key_${i}`] || 0;
        total += v;
        return i * v;
      }),
    ) / (total || 1);
  return {
    title: "Vape Proportion Percent",
    yes: val,
    no: 100 - val,
    labels: ["Proportion", "No"],
  };
}

export function getEaseStockKnowledgeVisibleConditionOrangisedDoughnut(
  type: string,
  data?: ReportDataModel,
) {
  const total = sum(
    [
      `${type}_key_rr_agree_4`,
      `${type}_key_rr_neither_3`,
      `${type}_key_rr_disagree_2`,
      `${type}_key_rr_stronglydisagree_1`,
    ].map((d) => data?.main[d] || 0),
  );
  return {
    title: titleStr(type),
    yes: data?.main[`${type}_key_rr_stronglyagree_5`] || 0,
    no: total,
    labels: ["Strongly Agree", "Other"],
  };
}

export function getVapeProductPromotional(
  data?: ReportDataModel,
): { label: string; value: number }[] {
  const keys = [...productKeys, "none"];
  const total = sum(keys.map((k) => data?.main[`promooffer_${k}_key_1`] || 0));
  return keys.map((k) => ({
    label: productLabelKey[k],
    value: (data?.main[`promooffer_${k}_key_1`] || 0) / total,
  }));
}

export function getVapeProductColleagueKnowledge(
  data?: ReportDataModel,
): { label: string; value: number }[] {
  const keys = [...productKeys];
  keys.splice(6, 0, "none");
  const total = sum(
    keys.map((k, i) => data?.main[`${k}_select_key_${i + 1}`] || 0),
  );
  return keys.map((k, i) => ({
    label: productLabelKey[k],
    value: (data?.main[`${k}_select_key_${i + 1}`] || 0) / total,
  }));
}

export function getVapeSharedShelf(data?: ReportDataModel) {
  const keys = [...productKeys].filter((a) => a !== "hayati");
  const arrs = Array(101).fill("");
  return keys.map((k, i) => {
    let total = 0;
    const val =
      sum(
        arrs.map((_, i) => {
          const v = data?.main[`${k}_percent_key_${i}`] || 0;
          total += v;
          return i * v;
        }),
      ) /
      (total || 1) /
      100;

    return {
      label: productLabelKey[k],
      value: val,
    };
  });
}

export function getVapeColleagueProductPromote(data?: ReportDataModel) {
  const keys = [...productKeys, "none"];
  const total = sum([
    data?.main.veryhigh_key_1,
    data?.main.high_key_2,
    data?.main.moderate_key_3,
    data?.main.low_key_4,
    data?.main.verylow_key_5,
  ]);
  return keys.map((k, i) => {
    const v = data?.main[`promote_${k}_key_1`] || 0;
    return {
      label: productLabelKey[k],
      value: v / (total || 1),
    };
  });
}
